import { useState } from "react";
import AuthSheet from "../screens/AuthSheet.jsx";
import Icon from "./Icon.jsx";
import { mark } from "../funnel.js";

/**
 * 로그인해야 지나갈 수 있는 문.
 *
 * ★ 이건 편의일 뿐 방어선이 아니다. 실제 차단은 서버가 한다
 * (functions/src/callerAuth.js 의 requireUser — 익명 토큰을 거부한다).
 * 화면만 가리면 함수를 직접 부르는 것으로 그대로 뚫린다.
 *
 * 익명을 막는 이유는 지갑이 아니라 **데이터 품질**이다. 동의와 인구통계가
 * 진짜 계정에 붙어야 하고, 브라우저를 지우면 철회할 창구가 사라지던 문제도
 * 계정이 있어야 없어진다. 그래서 그 이유를 화면에도 적는다 —
 * 「로그인하세요」만 있으면 사람들은 왜 막는지 모른 채 돌아간다.
 */
export default function LoginGate({ title, lead, onDone, onBack }) {
  const [sheet, setSheet] = useState(false);

  return (
    <main className="screen" style={{ minHeight: "100vh" }}>
      <header className="bar">
        {onBack && (
          <button type="button" className="icon-btn" aria-label="뒤로" onClick={onBack}>
            <Icon name="back" />
          </button>
        )}
        <span className="grow" />
      </header>

      <section className="card raised" style={{ borderRadius: 4, padding: "26px 22px", gap: 12 }}>
        <h1 className="d" style={{ fontSize: 30, lineHeight: 1.2 }}>{title}</h1>
        <p style={{ fontSize: 15, fontWeight: 700, lineHeight: 1.6 }}>{lead}</p>
        <p className="note" style={{ margin: 0 }}>
          기록이 계정에 남아야 다른 기기에서도 이어서 볼 수 있고,
          나중에 「이건 쓰지 말아 주세요」라고 말할 창구도 생겨요.
        </p>
        <button type="button" className="btn primary" onClick={() => { mark("loginSheet"); setSheet(true); }}>
          로그인하고 시작하기
        </button>
        <p className="note" style={{ margin: 0 }}>
          처음이면 이 자리에서 계정이 만들어져요.
        </p>
      </section>

      {sheet && (
        <AuthSheet
          mode="login"
          onClose={() => setSheet(false)}
          onDone={() => { mark("loginDone"); setSheet(false); onDone?.(); }}
        />
      )}
    </main>
  );
}
